var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-avatar',_vm._g({attrs:{"size":"24","color":"white"}},on),[_c('v-icon',{attrs:{"dark":"","small":"","color":_vm.statusObj.iconColor}},[_vm._v(_vm._s(_vm.statusObj.icon))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.statusObj.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }